import type { TOC } from '@ember/component/template-only'
import type { SafeString } from '@ember/template'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { Tooltip } from 'teacher-ui-client/components/tooltip'

interface Signature {
  Element: HTMLElement
  Args: {
    text?: string | SafeString
  }
}

export const CellTooltip: TOC<Signature> = <template>
  <sup class="print:hidden" ...attributes>
    <PhosphorIcon @icon="phosphor-info-fill" />
    <Tooltip @text={{@text}} />
  </sup>
</template>

export default CellTooltip
